<!-- 操作弹框 -->
<template>
  <div class="operateOne">
    <div class="operateList">
      <img
        class="img"
        style="transform: rotate(180deg)"
        src="../../../assets/images/icon-handle-down.png"
      />
      <img
        class="imgOn"
        src="../../../assets/images/icon-handle-up-active.png"
      />
      向上插入
      <i class="el-icon-arrow-right"></i>
      <div class="operateTwo">
        <div class="operateList" @click="operateInsertBlank(true)">
          空白栏位
        </div>
        <div class="operateList" @click="operateInsertCollection(true)">收藏栏位</div>
      </div>
    </div>
    <div class="operateList">
      <img
        class="img"
        src="../../../assets/images/icon-handle-down.png"
        alt=""
      />
      <img
        class="imgOn"
        src="../../../assets/images/icon-handle-up-active.png"
        style="transform: rotate(180deg)"
      />
      向下插入
      <i class="el-icon-arrow-right"></i>
      <div class="operateTwo">
        <div class="operateList" @click="operateInsertBlank(false)">
          空白栏位
        </div>
        <div class="operateList" @click="operateInsertCollection(false)">收藏栏位</div>
      </div>
    </div>
    <div class="operateList" @click="operateDelete">
      <img
        class="img"
        src="../../../assets/images/icon-handle-delete.png"
        alt=""
      />
      <img
        class="imgOn"
        src="../../../assets/images/icon-handle-delete-select.png"
      />
      删除
    </div>
    <div class="operateList" @click="operateCopy">
      <img
        class="img"
        src="../../../assets/images/icon-handle-copy.png"
        alt=""
      />
      <img
        class="imgOn"
        src="../../../assets/images/icon-handle-copy-select.png"
      />
      复制
    </div>
    <div class="operateList" @click="operateCollection">
      <img v-if="isCollection" class="img" src="../../../assets/images/icon_collection_select.png" alt="" />
      <img v-else class="img" src="../../../assets/images/icon-handle-collection.png" alt="" />
      <img v-if="isCollection" class="imgOn" src="../../../assets/images/icon_collection_select.png" alt="" />
      <img v-else class="imgOn" src="../../../assets/images/icon_collection_unselect.png" />
      收藏
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/utils/event-bus";
import {
    addStar,
    deleteStar,
    getCollectionStatus
} from "@/api/addModule";

export default {
  name: "OperateFrame",
  props: {
    id: {
      type: String,
    },
    fieldsArr: {
      type: Array,
    },
  },
  inject: ["getFormData"],
  data() {
    return {
        isCollection: false,
        collectionContentSingleId:0
    };
  },
  computed: {
    formData() {
      return this.getFormData();
    }
  },

  methods: {
    // 插入空白栏位 direction：true // 向上  flase // 向下
    operateInsertBlank(direction) {
      console.log(1234);
      this.$emit("operateInsertBlank", direction, this.id);
    },

    // 复制栏位
    operateCopy() {
      this.$emit("operateCopy", this.id);
    },

    // 插入收藏栏位
    operateInsertCollection(direction) {
      console.log('插入收藏栏位');
      EventBus.$emit("scjShow", {n1:true,n2:true,nowId: this.id, direction: direction, from: "content"});
    },

    // 删除栏位
    operateDelete() {
      this.$confirm(`是否删除此栏位?`, "删除提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        customClass: "customClass",
        confirmButtonClass: "btnConfirm",
        cancelButtonClass: "btnCancel",
      })
        .then(() => {
          EventBus.$emit("operateDelete", this.id);
        })
        .catch(() => {});
    },
	findSelectedItem() {
		let res = {};
		this.fieldsArr.some((item) => {
			console.log("item.id===============", item.id);
			console.log("this.id===============", this.id);
			console.log("id相等===============", item.id == this.id);
			if (item.id == this.id) {
				res = item;
				return;
			}
		});
		return res;
	},
    // 收藏栏位
    operateCollection() {
        console.log('coilingId==', this.$store.state.coilingId);
        console.log('id==', this.id);
        let currentField = this.fieldsArr.find((item) => item.id === this.id)
        console.log('currentField===', currentField)
        if (!currentField) {
            currentField = this.$store.state.fieldsJSON[0]
        }
        console.log('state.Field===', this.$store.state.fieldsJSON)
        if (!this.isCollection) {
            let type= this.$route.query.type
            if(Array.isArray(this.formData.type)){
              type= this.formData.type.join(',')
            }
            addStar({
                    coilingId: this.$store.state.coilingId,
                    area: this.$route.query.region,
                    type,
                    source: this.$route.query.questionSource,
                    year: this.$route.query.year,
                    collectionType: "test_single",
                    content: JSON.stringify(currentField),
                    pid: 0
                })
                .then((res) => {
                    console.log(res);
                    if (res["code"] == 0) {
                        this.collectionContentSingleId = res["data"];
                        console.log('id===', this.collectionId);
                        this.$message.success("收藏成功！");
                    } else {
                        this.$message.error("收藏失败！");
                        return;
                    }
                })
                .catch((err) => {
                    console.log("addStar err", err);
                });
        } else {
            deleteStar(this.collectionContentSingleId).then((res) => {
                if (res["code"] == 0) {
                    this.$message({
                        message: "取消收藏成功",
                        type: "success",
                    });
                    this.collectionId = 0
                } else {
                    this.$message.error("取消收藏失败");
                    return;
                }
            });
        }
        this.isCollection = !this.isCollection;
    },
    getCollectionStatus() {
        let currentField = this.fieldsArr.find((item) => item.id === this.id)
        let data = {
            collectionType: "test_single",
            coilingId: this.$store.state.coilingId,
            content: JSON.stringify(currentField),
        };
        console.log('getCollectionStatus_data====', data);
        getCollectionStatus(data)
            .then((res) => {
                this.collectionContentSingleId = res["data"];
                this.isCollection = this.collectionContentSingleId > 0
                console.log('this.collectionAnswerSingleId===', this.collectionAnswerSingleId)
            })
            .catch((err) => {
                console.log("getList err", err);
            });
    },
    // 收藏栏位
    /* operateCollection() {
		console.log("filedArr==", this.fieldsArr);
		let item = this.findSelectedItem();
		console.log('itemJSON====', JSON.stringify(item));
		this.$emit("collectionAdd", JSON.stringify(item));
		
      /* this.$emit("scjShow", {n1:true,n2:false});
      // this.$message({
      //   message: "删除栏位成功！",
      //   type: "success",
      // });
      this.$notify({
        title: "HTML 片段1",
        dangerouslyUseHTMLString: true,
        message:
          "<strong icon='el-icon-loading'>这是 <i>HTML</i> 片段</strong>",
      }); */
    //}, */
  },
  mounted() {
      this.getCollectionStatus()
  },
};
</script>

<style lang="scss" scoped>
.operateOne {
  width: 100%;
  // background: #fff;
  box-shadow: 0 0 6rem rgba(0, 0, 0, 0.1);
  padding: 10rem 0;
}

.operateList {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14rem;
  color: #666;
  height: 28rem;
  line-height: 28rem;
  cursor: pointer;
  img {
    width: 16rem;
    height: 16rem;
    margin: 0 5rem -2rem 11rem;
  }
  i {
    width: 10rem;
    height: 14rem;
    font-size: 14rem;
    margin: 2rem 0 0 2rem;
  }
  .imgOn {
    display: none;
  }
}

.operateList:hover {
  color: #0bae6a;
  background: #d5fae0;
  .img {
    display: none;
  }
  .imgOn {
    display: block;
  }
}

.operateList:hover .operateTwo {
  display: block;
}

.operateTwo {
  position: absolute;
  right: -103rem;
  top: -10rem;
  background: #fff;
  width: 100rem;
  box-shadow: 0 0 6rem rgba(0, 0, 0, 0.1);
  display: none;
  border: 1rem solid rgba(0, 0, 0, 0.15);
  padding: 10rem 0;

  .operateList {
    color: #666;
    height: 28rem;
    line-height: 28rem;
    text-align: center;
    width: 100%;
    display: block;
  }
  .operateList:hover {
    color: #0bae6a;
    background: #d5fae0;
  }
}
</style>

